import _slicedToArray from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _mergeWith from "lodash/mergeWith";
import _isArray from "lodash/isArray";
import _difference from "lodash/difference";
/* MIT License

Copyright(c) Sindre Sorhus < sindresorhus@gmail.com>
(https://sindresorhus.com)
Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files(the "Software"), to
deal in the Software without restriction, including without limitation the
rights to use, copy, modify, merge, publish, distribute, sublicense, and / or
sell copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:
The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.
THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
OTHER DEALINGS IN THE SOFTWARE.
*/
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.filter.js";
var getArray = function getArray(object) {
  return Object.keys(object).reduce(function (r, k) {
    object[k].forEach(function (a, i) {
      // eslint-disable-next-line no-param-reassign
      r[i] = r[i] || {};
      // eslint-disable-next-line no-param-reassign
      r[i][k] = a;
    });
    return r;
  }, []);
};
var isSubset = function isSubset(subsetArray, containingArray) {
  return _difference(subsetArray, containingArray).length === 0;
};

// Like reverse but it doesn't mutate underlying array
var reversed = function reversed(array) {
  return _toConsumableArray(array).reverse();
};
var removed = function removed(item, array) {
  return array.filter(function (currExpId) {
    return currExpId !== item;
  });
};
var arrayMoveMutable = function arrayMoveMutable(array, fromIndex, toIndex) {
  var startIndex = fromIndex < 0 ? array.length + fromIndex : fromIndex;
  if (startIndex >= 0 && startIndex < array.length) {
    var endIndex = toIndex < 0 ? array.length + toIndex : toIndex;
    var _array$splice = array.splice(fromIndex, 1),
      _array$splice2 = _slicedToArray(_array$splice, 1),
      item = _array$splice2[0];
    array.splice(endIndex, 0, item);
  }
};
var arrayMoveImmutable = function arrayMoveImmutable(array, fromIndex, toIndex) {
  // eslint-disable-next-line no-param-reassign
  array = _toConsumableArray(array);
  arrayMoveMutable(array, fromIndex, toIndex);
  return array;
};

/**
  This function merges objects replacing old arrays in its properties with
  the new ones unlike _.merge which combines old and new arrays.
 */
var mergeObjectReplacingArrays = function mergeObjectReplacingArrays(source, diff) {
  var arrayMerge = function arrayMerge(originalArray, resultingArray) {
    if (_isArray(originalArray) && resultingArray) {
      return resultingArray;
    }
  };
  return _mergeWith(source, diff, arrayMerge);
};
export { getArray, isSubset, reversed, removed, arrayMoveMutable, arrayMoveImmutable, mergeObjectReplacingArrays };